import { AstNodeCategory, AstNodeType } from './node';
export class InfixExpression {
    constructor(token, operator, left, right) {
        this.token = token;
        this.operator = operator;
        this.left = left;
        this.right = right;
        this.nodeType = AstNodeType.InfixExpression;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Operator() {
        return this.operator;
    }
    set Operator(val) {
        this.operator = val;
    }
    get Left() {
        return this.left;
    }
    set Left(val) {
        this.left = val;
    }
    get Right() {
        return this.right;
    }
    set Right(val) {
        this.right = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `(${this.left.toString()} ${this.operator} ${this.right.toString()})`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5maXhFeHByZXNzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvSW5maXhFeHByZXNzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFjLE1BQU0sUUFBUSxDQUFDO0FBRWxFLE1BQU0sT0FBTyxlQUFlO0lBQ3hCLFlBQ1ksS0FBWSxFQUNaLFFBQWlCLEVBQ2pCLElBQWlCLEVBQ2pCLEtBQWtCO1FBSGxCLFVBQUssR0FBTCxLQUFLLENBQU87UUFDWixhQUFRLEdBQVIsUUFBUSxDQUFTO1FBQ2pCLFNBQUksR0FBSixJQUFJLENBQWE7UUFDakIsVUFBSyxHQUFMLEtBQUssQ0FBYTtRQUc5QixhQUFRLEdBQWdCLFdBQVcsQ0FBQyxlQUFlLENBQUM7UUFDcEQsaUJBQVksR0FBb0IsZUFBZSxDQUFDLFVBQVUsQ0FBQztJQUh4RCxDQUFDO0lBS0osSUFBSSxRQUFRO1FBQ1IsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDO0lBQ3pCLENBQUM7SUFFRCxJQUFJLFFBQVEsQ0FBQyxHQUFHO1FBQ1osSUFBSSxDQUFDLFFBQVEsR0FBRyxHQUFHLENBQUM7SUFDeEIsQ0FBQztJQUVELElBQUksSUFBSTtRQUNKLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQztJQUNyQixDQUFDO0lBRUQsSUFBSSxJQUFJLENBQUMsR0FBRztRQUNSLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxJQUFJLEtBQUs7UUFDTCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDdEIsQ0FBQztJQUVELElBQUksS0FBSyxDQUFDLEdBQUc7UUFDVCxJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQztJQUNyQixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLElBQUssSUFBSSxDQUFDLElBQW1CLENBQUMsUUFBUSxFQUFFLElBQzNDLElBQUksQ0FBQyxRQUNULElBQUssSUFBSSxDQUFDLEtBQW9CLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQztJQUNqRCxDQUFDO0NBQ0oifQ==